import { Pipe, PipeTransform } from "@angular/core";

/** Returns just the time portion of datetime in HSS format. */
@Pipe({
  name: "hssTime",
  standalone: true,
})
export class HssTimePipe implements PipeTransform {
  transform(value: string): string {
    if (value.length === 19) {
      const hours = value.substring(11, 13);
      const minutes = value.substring(14, 16);
      return `${hours}${minutes}`;
    }
    return "    ";
  }
}
